module.exports = __webpack_public_path__ + "static/phdevlogo-1a3b46bdf86237c4939c54314b375b6a.png";